import styled from '../styled-components';
export const OneOfList = styled.ul.withConfig({
  displayName: "schema__OneOfList",
  componentId: "eno265-0"
})(["margin:0 0 3px 0;padding:0;list-style:none;display:inline-block;"]);
export const OneOfLabel = styled.span.withConfig({
  displayName: "schema__OneOfLabel",
  componentId: "eno265-1"
})(["font-size:0.9em;margin-right:10px;color:", ";font-family:", ";}"], props => props.theme.colors.primary.main, props => props.theme.typography.headings.fontFamily);
export const OneOfButton = styled.li.withConfig({
  displayName: "schema__OneOfButton",
  componentId: "eno265-2"
})(["display:inline-block;margin-right:10px;font-size:0.875em;cursor:pointer;border:2px solid #4863be;padding:6px 12px;border-radius:32px 32px 8px 32px;", ""], props => {
  if (props.active) {
    return `
      color: white;
      background-color: #4863BE;
      `;
  } else {
    return `
        color: #4863BE;
        background-color: transparent;

        &:hover {
          background-color: #fff;
        }
      `;
  }
});
export const ArrayOpenningLabel = styled.div.withConfig({
  displayName: "schema__ArrayOpenningLabel",
  componentId: "eno265-3"
})(["font-size:0.9em;font-family:", ";&::after{content:' [';}"], props => props.theme.typography.code.fontFamily);
export const ArrayClosingLabel = styled.div.withConfig({
  displayName: "schema__ArrayClosingLabel",
  componentId: "eno265-4"
})(["font-size:0.9em;font-family:", ";&::after{content:']';}"], props => props.theme.typography.code.fontFamily);